export default __webpack_public_path__ + "static/media/rolamentos-de-roda-534x444.1827e6e4.png";